import PocketBase from 'pocketbase';

const DEFAULT_POCKETBASE_URL = 'https://deep-met-bpas-video-hub-21122025.pockethost.io';

const normalizeBaseUrl = (value) => String(value || '')
  .trim()
  .replace(/\/+$/, '');

export const POCKETBASE_URL = normalizeBaseUrl(
  import.meta.env.VITE_POCKETBASE_URL || DEFAULT_POCKETBASE_URL
);

const pb = new PocketBase(POCKETBASE_URL);

// Keep duplicate requests independent. Several admin screens intentionally load
// related collections in parallel.
pb.autoCancellation(false);

export default pb;

export const isAuthenticated = () => pb.authStore.isValid;
export const getCurrentUser = () => pb.authStore.model;

export const logout = () => {
  pb.authStore.clear();
};

export const apiCall = async (fn) => {
  try {
    return await fn();
  } catch (error) {
    console.error('PocketBase API error:', error);
    throw error;
  }
};